import {DeviceStatus}          from '../../shared-gen/Device/Status/DeviceStatus';
import {VendingStatusFun}      from '../vending/vending-status.fun';
import {MachineStatusFun}      from '../machine/status/machine-status.fun';
import {PaymentStatusFun}      from '../payment/payment-status.fun';
import {SelectionsFun}         from '../model/selections/selections.fun';
import {UIConfigFun}           from '../model/devices/config/ui-config.fun';
import {VmcState}              from '../../shared-gen/Vending/Status/VmcState';
import { DeviceInfoFun }       from "../model/devices/device-info.fun";
import { LocationFun }         from "../model/locations/location.fun";
import { DataUpdateStatusFun } from "../updates/data/data-update-status.fun";
import { EntityHeaderFun }     from "../model/utils/entity-header.fun";
import { MemorySticksStatusFun } from "./memory-sticks-status.fun";

export class DeviceStatusFun {

	/**
	 * Returns an offline device status.
	 * Can be used when the server can not be reached.
	 */
	static offline(): DeviceStatus {
		return {
			DeviceInfo: DeviceInfoFun.createNew(),
			DeviceHeader: EntityHeaderFun.createNew(),
			Location: LocationFun.createNew(""),
			VendingStatus: VendingStatusFun.offline(),
			MachineStatus: MachineStatusFun.offline(),
			PaymentStatus: PaymentStatusFun.createNew(),
			Doors: {} as any,
			UIConfig: UIConfigFun.createNew(),
			MobileSelect: null as any,
			IsOnline: false,
			SoftwareVersion: "",
			DataUpdate: DataUpdateStatusFun.createNew(),
			MemorySticks: MemorySticksStatusFun.createNew()
		};
	}

	static getVmcState(_this: DeviceStatus): VmcState {
		return _this.VendingStatus.VmcState;
	}

}
